var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRotateCw = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M15.333 2c.368 0 .667.298.667.667v4a.667.667 0 0 1-.667.666h-4a.667.667 0 1 1 0-1.333h3.334V2.667c0-.369.298-.667.666-.667Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M8.752 2.72a5.333 5.333 0 1 0 4.28 7.058.667.667 0 0 1 1.257.444 6.666 6.666 0 1 1-1.578-6.94l3.08 2.9a.667.667 0 0 1-.915.97L11.79 4.245A5.333 5.333 0 0 0 8.752 2.72Z",
  clipRule: "evenodd"
})));
SvgRotateCw.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgRotateCw);
export default ForwardRef;